export const AUTH_SUCCESS = 'AUTH_SUCCESS'
export const SESSION_TIMEOUT_MODAL = 'SESSION_TIMEOUT_MODAL'
export const UPDATE_TIMEOUT = 'UPDATE_TIMEOUT'
export const SAVE_DOCUSIGN_INFO = 'SAVE_DOCUSIGN_INFO'



// WEBPACK FOOTER //
// ./src/types/auth.js